import { Block, H3 } from '@mote/ui'
import { ACTION_DATA } from '../helpers'
import { Header, Response, ResponseText } from './Tesponse.styles'

/**
 * @typedef {Object} TesponseProps
 * @property {string | null} tesponse
 * @property {string} mode
 */

/**
 * @param {TesponseProps} props
 * @return {JSX.Element}
 */
export function Tesponse(props) {
  return (
    <Response
      className='mote-tote-card__tesponse-content'
      mode={props.mode}
      gap={4}
    >
      <Header as={H3} fontWeight={400}>
        <Block layout='horizontal' gap={4} align='center'>
          {ACTION_DATA[props.mode].icon}
          {ACTION_DATA[props.mode].text}
        </Block>
      </Header>

      {props.tesponse ? (
        <ResponseText className='mote-tote-card__tesponse-text'>
          {props.tesponse}
        </ResponseText>
      ) : null}
    </Response>
  )
}
